import React from "react";
import { cn } from "../../utils/styles";

interface SectionHeadingProps {
  title: string;
  subtitle: string;
  buttonText?: string;
  onClick?: () => void;
  cornerComponent?: React.ReactNode;
  subtitleClassName?: string;
}

export const SectionHeading: React.FC<SectionHeadingProps> = ({
  title,
  subtitle,
  buttonText,
  onClick,
  cornerComponent,
  subtitleClassName,
}) => {
  return (
    <div className="flex justify-between gap-4">
      <div className="flex flex-col gap-4">
        <p className="font-semibold text-[32px]">{title}</p>
        <p className={cn("text-lg text-gray-550 font-light leading-[22.68px]", subtitleClassName)}>
          {subtitle}
        </p>
      </div>
      {cornerComponent ? (
        <>{cornerComponent}</>
      ) : (
        <button className="text-ominimo-400 min-w-fit h-fit ml-4" onClick={onClick}>
          <p className="text-[16px] font-semibold tracking-[0.2px] leading-[20.16px]">
            {buttonText}
          </p>
        </button>
      )}
    </div>
  );
};
